import { Component, Input, OnInit } from '@angular/core';

import {
  BibliographicResource,
  OnlineResource,
} from '®shared/bibliographic-resource';
import {
  BOOKJACKET_IMAGE_WIDTH_LARGE,
  ResourceImageUtils,
} from '®shared/container-structure';

@Component({
  selector: 'rl-resource-details',
  templateUrl: './resource-details.component.html',
})
export class ResourceDetailsComponent implements OnInit {
  @Input() bibliographicResource: BibliographicResource;
  @Input() resourceImage: string;
  @Input() onlineResource: OnlineResource;

  resourceImageUrl: string;

  ngOnInit(): void {
    this.resourceImageUrl =
      this.resourceImage ??
      ResourceImageUtils.buildPlaceholderImageURL(
        this.bibliographicResource,
        BOOKJACKET_IMAGE_WIDTH_LARGE,
      );
  }
}
